import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CenterFrameLayout } from 'Layouts';
import { fetchSheerIdInfo } from 'State/User/UserActions';
import ProfileSignIn from '../ProfileSignIn';
import './SignInLayoutV2.css';

export const SignInLayoutV2 = (props) => {
  const dispatch = useDispatch();
  const user = useSelector((s) => s.user);
  const { bango, isSpecialPromo } = useSelector((s) => s.integrations);

  useEffect(() => {
    dispatch(fetchSheerIdInfo());
  }, [dispatch]);

  const title = bango.subscriptionId ? 'Sign in' : 'Sign in to watch';

  return (
    <CenterFrameLayout customClass="signInLayout" noPanel title={title} showLoader={user.isFetching}>
      <div className="signIn">
        <div className="panel profile">
          <div className="panelWrapper">
            <ProfileSignIn {...props} bango={bango} isSpecialPromo={isSpecialPromo} user={user} />
          </div>
        </div>
      </div>
    </CenterFrameLayout>
  );
};
